import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { defaultConfig } from "../config";
import { JobsManager } from "../jobs";
import { NetworkManager } from "../network";
import { CheckoutRepositoryManager, LocalRepository } from "../repository";
import { SaleorState } from "../state";
import { SaleorCartAPI } from "./Cart";
import { SaleorCheckoutAPI } from "./Checkout";
export * from "./Checkout";
export * from "./Cart";
export var SaleorAPI =
/**
 * @deprecated Please do not use it anymore. Reference to API Proxy will be removed in future.
 * Now it just exists for legacy React hooks, which also will be removed.
 */
function SaleorAPI(client, apiProxy, config, onStateUpdate) {
  _classCallCheck(this, SaleorAPI);

  this.legacyAPIProxy = apiProxy;

  var finalConfig = _objectSpread({}, defaultConfig, config, {
    loadOnStart: _objectSpread({}, defaultConfig.loadOnStart, config === null || config === void 0 ? void 0 : config.loadOnStart)
  });

  var loadOnStart = finalConfig.loadOnStart,
      languageCode = finalConfig.languageCode;
  var repository = new LocalRepository();
  var networkManager = new NetworkManager(client, languageCode);
  var saleorState = new SaleorState(repository, networkManager);
  var checkoutRepositoryManager = new CheckoutRepositoryManager(repository, saleorState);
  var jobsManager = new JobsManager(repository, networkManager);

  if (onStateUpdate) {
    saleorState.subscribeToNotifiedChanges(onStateUpdate);
  }

  this.checkout = new SaleorCheckoutAPI(saleorState, loadOnStart.checkout, jobsManager);
  this.cart = new SaleorCartAPI(checkoutRepositoryManager, networkManager, saleorState, loadOnStart.cart, jobsManager);
  this.legacyAPIProxy.attachAuthListener(function (authenticated) {
    if (!authenticated) {
      repository.setCheckout({});
      repository.setPayment({});
      repository.setJobs(null);
    }
  });
};